// src/components/CashOrderSuccess/index.js - CLEAN ARCHITECTURE
import React, { useEffect, useState } from 'react';
import { CheckCircle, PhoneCall } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './index.css';

const CashOrderSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const [orderInfo, setOrderInfo] = useState(null);
  const [storePhone, setStorePhone] = useState(null);

  useEffect(() => {
    console.log('💵 Cash Order Success page mounted');

    // Clear only cart data for the current store from localStorage
    try {
      const storeDetails = JSON.parse(sessionStorage.getItem('selected_store_details') || 'null');
      if (storeDetails?.phone) {
        setStorePhone(storeDetails.phone);
      }
      const storeIdToClear = storeDetails ? storeDetails.id : null;

      const keysToRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && storeIdToClear && key.startsWith(`resto_cart_data_${storeIdToClear}_`)) {
          keysToRemove.push(key);
        } else if (key && !storeIdToClear && key.startsWith('resto_cart_data_')) {
          // Fallback if no store info found
          keysToRemove.push(key);
        }
      }
      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });
      window.dispatchEvent(new Event('cart_updated'));
    } catch (error) {
      console.error('❌ Error clearing cart:', error);
    }
  }, []);

  useEffect(() => {
    const orderId = searchParams.get('order');
    if (orderId) {
      setOrderInfo({ orderId, paymentMethod: 'cash' });
    }
  }, [searchParams]);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => setCountdown(c => c - 1), 1000);
      return () => clearInterval(timer);
    }

    if (countdown === 0) {
      handleRedirect();
    }
  }, [countdown]);

  const handleRedirect = () => {
    // Try to get the store slug from sessionStorage
    try {
      const storeDetails = JSON.parse(sessionStorage.getItem('selected_store_details') || 'null');
      if (storeDetails?.name) {
        const storeSlug = storeDetails.name.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        navigate(`/restaurant/${storeSlug}`, { replace: true });
        return;
      }
    } catch (e) {
      // ignore
    }

    // Fallback to home
    navigate('/', { replace: true });
  };

  return (
    <div className="pp-container">
      <div className="pp-success-circle">
        <CheckCircle size={48} color="#16a34a" />
      </div>

      <h2 className="pp-title">Order Confirmed!</h2>

      {orderInfo?.orderId && (
        <div className="pp-order-id">
          <span className="pp-order-id-label">Order ID:</span>
          <span className="pp-order-id-value">#{orderInfo.orderId}</span>
        </div>
      )}

      <div className="pp-subtext" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '1.25rem', fontWeight: '500', color: '#1f2937', marginTop: '1rem', marginBottom: '1.5rem', lineHeight: '1.5', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <PhoneCall size={22} color="#16a34a" />
          <span>Our staff will contact you for processing the order.</span>
        </div>
        {storePhone && (
          <div style={{ marginTop: '0.5rem', fontSize: '1.1rem', color: '#4b5563' }}>
            Or call us at <strong>{storePhone}</strong>
          </div>
        )}
      </div>

      <div className="pp-payment-method">
        <span className="pp-payment-badge">💵 Pay Later</span>
      </div>

      <div className="pp-redirect">
        Returning to menu in {countdown}s
      </div>

      <button
        className="pp-manual-redirect"
        onClick={handleRedirect}
      >
        Return to Menu Now
      </button>
    </div>
  );
};

export default CashOrderSuccess;